import { Component } from '@theme/component';

/**
 * Click-to-play video, ported from components/VideoSpeler.js.
 *
 * The <video> lives in a <template> until the poster is clicked, so a row of
 * six clips costs six images rather than six metadata fetches.
 *
 * @extends {Component}
 */
class AwhPlayer extends Component {
  /** `event.target`, not `currentTarget` — component.js delegates on document. */
  play = () => {
    const tpl = this.querySelector('[ref="tpl"]');
    const btn = this.querySelector('[ref="start"]');
    if (!(tpl instanceof HTMLTemplateElement)) return;

    const frag = tpl.content.cloneNode(true);
    const video = frag.querySelector('video');
    tpl.replaceWith(frag);
    btn?.remove();

    // The element only has a src once it is in the document, so play on the
    // next frame rather than against a video that has nothing to play.
    requestAnimationFrame(() => {
      const el = this.querySelector('video');
      el?.play?.().catch(() => {});
      el?.addEventListener('ended', () => el.load(), { once: true });
    });
    void video;
  };
}

if (!customElements.get('awh-player-component')) {
  customElements.define('awh-player-component', AwhPlayer);
}
